import axios from 'axios';
import config from '@/config/config';
import { CATALOGS } from '@/helpers/constants';

const urlMain = config.getParam('apiDomain') + 'catalogs/';

const states = {};
const getters = {};
CATALOGS.forEach(item => {
    getters[item.type] = state => states[item.type] ? JSON.parse(states[item.type]) : [];
});

export default {
    getters,
    state: states,
    mutations: {
        clear() {
            CATALOGS.forEach(item => {
                states[item] = [];
            });
        },
        setState(state, type) {
            state[type] = localStorage.getItem(`list:${type}`);
        },
    },
    actions: {
        async setCatalogAll() {
            for (const item of CATALOGS) {
                await this.dispatch('setCatalog', item);
            }
        },
        setCatalog({ commit }, item) {
            if (!item.url) {
                return;
            }

            return new Promise((resolve, reject) => {
                axios({
                    url: (urlMain + item.url),
                    method: 'GET',
                })
                    .then(resp => {
                        localStorage.setItem('list:' + item.type, JSON.stringify(resp.data));
                        commit('setState', item.type);
                        resolve(resp);
                    })
                    .catch(err => {
                        localStorage.removeItem('list:' + item.type);
                        reject(err.response.data.message);
                    });
            });
        },
        catalogClearAll({ commit }) {
            commit('clear');
            CATALOGS.forEach(item => localStorage.removeItem(`list:${item.type}`));
        },
    },
};